import {RootState} from '../../../testutils/configureStore'

export const getIsOneTimePasswordOpen = (state: RootState) =>
  state.oneTimePassword?.isOpen

export const getIsPhoneNumberVerified = (state: RootState) =>
  state.oneTimePassword?.isPhoneVerified
